import type { Title } from "@/types";

export const titles: Title[] = [
  {
    id: "t01",
    name: "雾中灯塔",
    type: "movie",
    region: "中国大陆",
    year: 2024,
    genres: ["剧情", "悬疑"],
    director: "陈默",
    cast: ["林深", "苏晴", "周砚"],
    duration: "118 分钟",
    rating: 8.6,
    cover:
      "https://readdy.ai/api/search-image?query=a%20solitary%20lighthouse%20wrapped%20in%20thick%20cold%20fog%20on%20a%20dark%20rocky%20coast%2C%20a%20faint%20amber%20beam%20cutting%20through%20the%20mist%2C%20cinematic%20movie%20poster%20art%2C%20dramatic%20moody%20lighting%2C%20rich%20cinematic%20color%20grading%2C%20fine%20film%20grain%2C%20premium%20editorial%20composition%2C%20highly%20detailed%2C%20no%20text&width=600&height=800&seq=cover-t01&orientation=portrait",
    short: "一座停摆的灯塔，一桩被浓雾掩埋了二十年的旧案。",
    synopsis:
      "海边小镇的灯塔管理员林深在一次暴风雨后发现了一本尘封的航海日志，日志里的记录与二十年前的一桩失踪案惊人地吻合。随着他逐页翻开真相，小镇上看似平静的邻里关系开始出现裂痕。妻子苏晴的沉默、老船长周砚的闪烁其词，让林深意识到，每个人都在为同一片浓雾守护着各自的秘密。当最后一页日志被读起，灯塔的灯重新亮起，照亮的却是一个谁都不愿面对的答案。",
    tags: ["悬疑", "海岛", "旧案", "人性"],
    releaseDate: "2024-03-15",
    popularity: 96,
    specialIds: ["s01"],
    reviews: [
      {
        id: "r01",
        user: "深夜看片的人",
        rating: 5,
        date: "2024-03-20",
        content: "节奏克制但张力十足，雾的意象用得太高级了，结尾那束光值得反复回味。",
      },
      {
        id: "r02",
        user: "胶片收藏家",
        rating: 4,
        date: "2024-03-22",
        content: "摄影和配乐是加分项，中段稍慢，但三线交错收束得很干净。",
      },
      {
        id: "r03",
        user: "橘子汽水",
        rating: 5,
        date: "2024-04-01",
        content: "苏晴这个角色太有层次了，看完久久缓不过来，推荐给所有喜欢慢悬疑的人。",
      },
    ],
  },
  {
    id: "t02",
    name: "第五个冬天",
    type: "movie",
    region: "中国大陆",
    year: 2023,
    genres: ["剧情", "爱情"],
    director: "周梅",
    cast: ["顾城", "白露", "韩雪"],
    duration: "126 分钟",
    rating: 8.2,
    cover:
      "https://readdy.ai/api/search-image?query=a%20quiet%20snowy%20village%20at%20dusk%2C%20a%20lone%20figure%20in%20a%20warm%20coat%20walking%20along%20a%20frozen%20lane%2C%20cinematic%20movie%20poster%20art%2C%20dramatic%20moody%20lighting%2C%20rich%20cinematic%20color%20grading%2C%20fine%20film%20grain%2C%20premium%20editorial%20composition%2C%20highly%20detailed%2C%20no%20text&width=600&height=800&seq=cover-t02&orientation=portrait",
    short: "他们约定每年冬天见一面，直到第五个冬天没有出现。",
    synopsis:
      "摄影师顾城与小学教师白露因一场大雪在北方小城相识，两人约定每年冬天在同一家旧书店见面。第一个冬天他们聊电影，第二个冬天他们争吵，第三个冬天他们沉默，第四个冬天他们几乎是陌生人。到了第五个冬天，书店要关门了，其中一个人却没有来。影片用四个冬天拼出一段感情的完整形状，平静地讲述关于错过与成长的故事。",
    tags: ["爱情", "文艺", "冬日", "遗憾"],
    releaseDate: "2023-12-08",
    popularity: 82,
    specialIds: ["s02"],
    reviews: [
      {
        id: "r04",
        user: "冬天不冷",
        rating: 5,
        date: "2023-12-12",
        content: "像一封写给旧时光的信，安静但很扎实，看完鼻子酸酸的。",
      },
      {
        id: "r05",
        user: "慢镜头爱好者",
        rating: 4,
        date: "2023-12-15",
        content: "构图很美，演员的留白表演加分，只是节奏需要一点耐心。",
      },
      {
        id: "r06",
        user: "肉桂卷",
        rating: 4,
        date: "2023-12-20",
        content: "没有刻意煽情，克制反而让人更难受，冬天看刚刚好。",
      },
    ],
  },
  {
    id: "t03",
    name: "机械之心",
    type: "movie",
    region: "美国",
    year: 2025,
    genres: ["科幻", "动作"],
    director: "Alan Reeve",
    cast: ["马克·雷恩", "伊莎·科兰", "乔什·布莱尔"],
    duration: "142 分钟",
    rating: 8.9,
    cover:
      "https://readdy.ai/api/search-image?query=a%20futuristic%20humanoid%20robot%20chest%20revealing%20a%20glowing%20mechanical%20heart%20inside%20a%20neon%20sci-fi%20laboratory%2C%20cinematic%20movie%20poster%20art%2C%20dramatic%20moody%20lighting%2C%20rich%20cinematic%20color%20grading%2C%20fine%20film%20grain%2C%20premium%20editorial%20composition%2C%20highly%20detailed%2C%20no%20text&width=600&height=800&seq=cover-t03&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=a%20vast%20futuristic%20sci-fi%20city%20with%20glowing%20skyscrapers%20and%20flying%20vehicles%20under%20a%20deep%20indigo%20sky%2C%20cinematic%20wide%20film%20still%2C%20dramatic%20atmospheric%20lighting%2C%20rich%20color%20grading%2C%20epic%20composition%2C%20soft%20film%20grain%2C%20highly%20detailed%2C%20no%20text&width=1600&height=900&seq=backdrop-t03&orientation=landscape",
    short: "当机器人学会做梦，人类才第一次害怕自己造出的心。",
    synopsis:
      "在不远的未来，仿生人已经融入城市的每个角落。工程师马克负责回收一批出现“情绪异常”的旧型号仿生人，却在其中一台名为伊莎的机体里，发现了一段不属于任何数据库的记忆。为了查明这段记忆的来源，马克一步步走进公司严禁触碰的核心档案室，也逐渐开始怀疑：究竟是人类给了机械一颗心，还是机械早就在教人类如何拥有心。",
    tags: ["科幻", "人工智能", "未来", "动作"],
    releaseDate: "2025-06-20",
    popularity: 99,
    specialIds: ["s03"],
    reviews: [
      {
        id: "r07",
        user: "赛博观察员",
        rating: 5,
        date: "2025-06-25",
        content: "视效炸裂，但真正打动我的是它对“意识”的温柔提问，年度最佳科幻之一。",
      },
      {
        id: "r08",
        user: "爆米花星人",
        rating: 5,
        date: "2025-06-28",
        content: "动作场面拉满，中段的记忆闪回运镜帅到起飞，二刷安排。",
      },
      {
        id: "r09",
        user: "夜航船",
        rating: 4,
        date: "2025-07-02",
        content: "概念很宏大，收尾稍微仓促，但情感线立住了，值得进影院。",
      },
    ],
  },
  {
    id: "t04",
    name: "山海拾光",
    type: "movie",
    region: "中国大陆",
    year: 2024,
    genres: ["奇幻", "冒险"],
    director: "陆川白",
    cast: ["江淮", "柳絮", "沈迟"],
    duration: "134 分钟",
    rating: 7.8,
    cover:
      "https://readdy.ai/api/search-image?query=an%20ancient%20mythical%20mountain%20range%20with%20floating%20islands%20and%20glowing%20clouds%20at%20sunset%2C%20epic%20fantasy%20landscape%2C%20cinematic%20movie%20poster%20art%2C%20dramatic%20moody%20lighting%2C%20rich%20cinematic%20color%20grading%2C%20fine%20film%20grain%2C%20premium%20editorial%20composition%2C%20highly%20detailed%2C%20no%20text&width=600&height=800&seq=cover-t04&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=a%20sweeping%20mythical%20oriental%20fantasy%20landscape%20with%20floating%20mountains%20waterfalls%20and%20glowing%20clouds%20at%20golden%20hour%2C%20cinematic%20wide%20film%20still%2C%20dramatic%20atmospheric%20lighting%2C%20rich%20color%20grading%2C%20epic%20composition%2C%20soft%20film%20grain%2C%20highly%20detailed%2C%20no%20text&width=1600&height=900&seq=backdrop-t04&orientation=landscape",
    short: "一本残缺的山海图，引出一场跨越千年的拾光之旅。",
    synopsis:
      "少年江淮在祖父的旧书堆里找到半卷《山海拾光图》，图上描绘的神兽与山川竟与现实一一对应。为了找回失落的另一半图卷，他与柳絮踏上旅途，穿过会唱歌的荒漠、会记忆的湖，也逐渐发现祖父当年消失的秘密与这片土地的命运紧密相连。影片以瑰丽的想象重建了一个会呼吸的东方奇幻世界。",
    tags: ["奇幻", "国风", "冒险", "成长"],
    releaseDate: "2024-08-10",
    popularity: 88,
    specialIds: ["s03"],
    reviews: [
      {
        id: "r10",
        user: "国风控",
        rating: 4,
        date: "2024-08-14",
        content: "美术概念真的绝了，很多场景截图就是壁纸，故事稍弱但氛围满分。",
      },
      {
        id: "r11",
        user: "地图收藏家",
        rating: 4,
        date: "2024-08-18",
        content: "世界观铺得很大，适合带小朋友一起看，想象力值得点赞。",
      },
      {
        id: "r12",
        user: "阿麦",
        rating: 3,
        date: "2024-08-22",
        content: "前半段惊艳后半段略赶，但冲着美术也愿意二刷。",
      },
    ],
  },
  {
    id: "t05",
    name: "午夜出租车",
    type: "movie",
    region: "中国大陆",
    year: 2023,
    genres: ["悬疑", "犯罪"],
    director: "高弘",
    cast: ["郑野", "方琳", "罗大川"],
    duration: "105 分钟",
    rating: 8.1,
    cover:
      "https://readdy.ai/api/search-image?query=a%20lone%20yellow%20taxi%20on%20a%20rain%20soaked%20empty%20city%20street%20at%20midnight%20with%20reflected%20neon%20lights%2C%20cinematic%20movie%20poster%20art%2C%20dramatic%20moody%20lighting%2C%20rich%20cinematic%20color%20grading%2C%20fine%20film%20grain%2C%20premium%20editorial%20composition%2C%20highly%20detailed%2C%20no%20text&width=600&height=800&seq=cover-t05&orientation=portrait",
    short: "一个夜班司机，一段不能说的载客记录，一场雨夜的追逐。",
    synopsis:
      "出租车司机郑野习惯把每一单乘客的目的地记在本子上。某个雨夜，他接到一位付了双倍车费却不愿说目的地乘客，随后一连串的怪事接踵而来。为了弄清真相，郑野和女警方琳联手，沿着城市的午夜路线一步步逼近一个被精心掩盖多年的秘密。影片以雨夜为底色，勾勒出都市角落里那些被忽略的人。",
    tags: ["悬疑", "都市", "犯罪", "雨夜"],
    releaseDate: "2023-10-27",
    popularity: 78,
    specialIds: ["s01"],
    reviews: [
      {
        id: "r13",
        user: "夜班族",
        rating: 4,
        date: "2023-11-01",
        content: "低成本但有味道，雨戏拍得特别有氛围，结尾反转合理。",
      },
      {
        id: "r14",
        user: "老张看电影",
        rating: 4,
        date: "2023-11-05",
        content: "人物都挺真实的，没有开挂式推理，难得。",
      },
      {
        id: "r15",
        user: "薄荷糖",
        rating: 4,
        date: "2023-11-09",
        content: "节奏紧凑，通勤路上看完很解压，推荐。",
      },
    ],
  },
  {
    id: "t06",
    name: "海边来信",
    type: "movie",
    region: "日本",
    year: 2024,
    genres: ["剧情", "文艺"],
    director: "佐藤凉",
    cast: ["河野葵", "白石澪"],
    duration: "112 分钟",
    rating: 8.4,
    cover:
      "https://readdy.ai/api/search-image?query=a%20minimalist%20seaside%20scene%20with%20a%20single%20wooden%20mailbox%20on%20a%20quiet%20beach%20at%20golden%20hour%2C%20cinematic%20movie%20poster%20art%2C%20dramatic%20moody%20lighting%2C%20rich%20cinematic%20color%20grading%2C%20fine%20film%20grain%2C%20premium%20editorial%20composition%2C%20highly%20detailed%2C%20no%20text&width=600&height=800&seq=cover-t06&orientation=portrait",
    short: "她每天给一个不会回信的人写信，直到海把回信送回来。",
    synopsis:
      "独居海边小镇的河野葵每天清晨都会往一个早已停用的邮箱投递一封信，收信人是一个她再也不会见到的人。某天，邮箱里意外出现了回信，笔迹陌生却熟悉。她循着信里的线索重新走进那段被她封存的记忆，也在一次次潮起潮落中，学会了与告别和解。影片安静、缓慢，却有着极强的治愈力量。",
    tags: ["文艺", "治愈", "海岛", "记忆"],
    releaseDate: "2024-05-24",
    popularity: 74,
    specialIds: ["s02"],
    reviews: [
      {
        id: "r16",
        user: "海风信箱",
        rating: 5,
        date: "2024-05-28",
        content: "安静到能听见海浪声，非常适合一个人深夜看，治愈值拉满。",
      },
      {
        id: "r17",
        user: "慢生活",
        rating: 5,
        date: "2024-06-01",
        content: "没有大起大落，却把告别讲得如此温柔，看哭了。",
      },
      {
        id: "r18",
        user: "柠檬茶",
        rating: 4,
        date: "2024-06-05",
        content: "摄影和配乐都是顶级，适合静下心来慢慢品。",
      },
    ],
  },
  {
    id: "t07",
    name: "追风少年",
    type: "movie",
    region: "中国大陆",
    year: 2022,
    genres: ["运动", "励志"],
    director: "邓一鸣",
    cast: ["陈小北", "罗晴", "许阳"],
    duration: "108 分钟",
    rating: 7.6,
    cover:
      "https://readdy.ai/api/search-image?query=teenage%20runners%20sprinting%20on%20an%20outdoor%20track%20at%20sunrise%20with%20dust%20and%20motion%20energy%2C%20cinematic%20movie%20poster%20art%2C%20dramatic%20moody%20lighting%2C%20rich%20cinematic%20color%20grading%2C%20fine%20film%20grain%2C%20premium%20editorial%20composition%2C%20highly%20detailed%2C%20no%20text&width=600&height=800&seq=cover-t07&orientation=portrait",
    short: "一个被退队的少年，用一条跑道重新跑回自己的人生。",
    synopsis:
      "短跑少年陈小北因为一次伤病被省队退训，回到小城后几乎放弃梦想。在教练罗晴的坚持下，他重新站上跑道，与一群同样不被看好的伙伴一起备战市级赛。训练、挫败、伤病与误解轮番袭来，但他们最终明白：追的从来不只是终点线，而是那个还愿意奔跑的自己。一部关于青春与坚持的热血之作。",
    tags: ["运动", "青春", "励志", "热血"],
    releaseDate: "2022-09-30",
    popularity: 66,
    specialIds: [],
    reviews: [
      {
        id: "r19",
        user: "跑道边的人",
        rating: 4,
        date: "2022-10-03",
        content: "虽然套路但很燃，最后那场决赛看得我起鸡皮疙瘩。",
      },
      {
        id: "r20",
        user: "体育老师",
        rating: 4,
        date: "2022-10-08",
        content: "适合全家一起看，励志不油腻，孩子很喜欢。",
      },
      {
        id: "r21",
        user: "橙子",
        rating: 3,
        date: "2022-10-12",
        content: "中规中矩的青春片，但情绪到位，看个爽就行。",
      },
    ],
  },
  {
    id: "t08",
    name: "量子回声",
    type: "movie",
    region: "中国大陆",
    year: 2025,
    genres: ["科幻", "悬疑"],
    director: "何未",
    cast: ["沈砚", "江离", "顾远"],
    duration: "130 分钟",
    rating: 8.7,
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20quantum%20light%20particles%20forming%20a%20spiral%20in%20deep%20space%2C%20futuristic%20scientific%20atmosphere%2C%20cinematic%20movie%20poster%20art%2C%20dramatic%20moody%20lighting%2C%20rich%20cinematic%20color%20grading%2C%20fine%20film%20grain%2C%20premium%20editorial%20composition%2C%20highly%20detailed%2C%20no%20text&width=600&height=800&seq=cover-t08&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=a%20deep%20space%20scene%20with%20a%20swirling%20spiral%20of%20glowing%20quantum%20light%20particles%20and%20distant%20stars%2C%20cinematic%20wide%20film%20still%2C%20dramatic%20atmospheric%20lighting%2C%20rich%20color%20grading%2C%20epic%20composition%2C%20soft%20film%20grain%2C%20highly%20detailed%2C%20no%20text&width=1600&height=900&seq=backdrop-t08&orientation=landscape",
    short: "每一次观测，都让过去多出一个版本。",
    synopsis:
      "物理学家沈砚在一次量子实验事故后，开始收到来自“另一个自己”的讯息。这些讯息精准地预言了即将发生的事，却也一步步把现实推向崩塌的边缘。为了阻止失控，他与助手江离必须弄清：所谓的回声，究竟是来自平行宇宙的求救，还是他自己的执念在作祟。影片在硬核设定之下，探讨了选择与代价。",
    tags: ["科幻", "量子", "烧脑", "平行世界"],
    releaseDate: "2025-04-18",
    popularity: 92,
    specialIds: ["s01", "s03"],
    reviews: [
      {
        id: "r22",
        user: "物理系逃兵",
        rating: 5,
        date: "2025-04-22",
        content: "设定经得起推敲，逻辑闭环做得漂亮，国产科幻的高分答卷。",
      },
      {
        id: "r23",
        user: "烧脑上头",
        rating: 5,
        date: "2025-04-26",
        content: "第一遍看剧情，第二遍看细节，第三遍才看懂结局，太爽了。",
      },
      {
        id: "r24",
        user: "夜猫子",
        rating: 4,
        date: "2025-04-30",
        content: "信息量很大，需要专注，稍微走神就会跟不上，但值得。",
      },
    ],
  },
  {
    id: "t09",
    name: "长夜未央",
    type: "tv",
    region: "中国大陆",
    year: 2024,
    genres: ["古装", "权谋"],
    director: "秦风",
    cast: ["萧决", "苏挽月", "裴昭"],
    duration: "全 40 集",
    rating: 9.0,
    cover:
      "https://readdy.ai/api/search-image?query=an%20ancient%20chinese%20palace%20hall%20at%20night%20with%20warm%20lantern%20light%20and%20flowing%20silk%20curtains%2C%20majestic%20imperial%20mood%2C%20cinematic%20movie%20poster%20art%2C%20dramatic%20moody%20lighting%2C%20rich%20cinematic%20color%20grading%2C%20fine%20film%20grain%2C%20premium%20editorial%20composition%2C%20highly%20detailed%2C%20no%20text&width=600&height=800&seq=cover-t09&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=a%20grand%20ancient%20chinese%20imperial%20palace%20courtyard%20at%20night%20with%20hundreds%20of%20glowing%20lanterns%20and%20silk%20banners%2C%20cinematic%20wide%20film%20still%2C%20dramatic%20atmospheric%20lighting%2C%20rich%20color%20grading%2C%20epic%20composition%2C%20soft%20film%20grain%2C%20highly%20detailed%2C%20no%20text&width=1600&height=900&seq=backdrop-t09&orientation=landscape",
    short: "这一夜很长，长到足够改写一整个王朝的走向。",
    synopsis:
      "先帝骤然驾崩，朝堂暗流涌动。镇北将军萧决奉命回京，卷入太子与摄政王之间的权力漩涡。谋士苏挽月以棋局隐喻朝局，多次在关键时刻扭转乾坤，却始终不肯说出自己的真实身份。随着一桩桩旧案被揭开，萧决发现自己守护的，可能并不是他以为的那个天下。全剧以缜密的权谋交锋与克制的情感线，讲述一盘下了十年的棋。",
    tags: ["古装", "权谋", "群像", "朝堂"],
    releaseDate: "2024-11-01",
    popularity: 100,
    specialIds: ["s04"],
    reviews: [
      {
        id: "r25",
        user: "追剧第一名",
        rating: 5,
        date: "2024-11-05",
        content: "台词功底太强了，每句都是伏笔，堪称年度最佳权谋剧。",
      },
      {
        id: "r26",
        user: "古装十级学者",
        rating: 5,
        date: "2024-11-10",
        content: "服化道精致，群像没有工具人，配角个个立得住。",
      },
      {
        id: "r27",
        user: "通宵战士",
        rating: 5,
        date: "2024-11-18",
        content: "一口气刷完，中后期几次反转完全猜不到，跪着看完。",
      },
    ],
  },
  {
    id: "t10",
    name: "城市边缘",
    type: "tv",
    region: "中国大陆",
    year: 2023,
    genres: ["都市", "悬疑"],
    director: "林奕",
    cast: ["周牧", "温言", "高野"],
    duration: "全 32 集",
    rating: 8.5,
    cover:
      "https://readdy.ai/api/search-image?query=a%20moody%20modern%20city%20skyline%20at%20blue%20hour%20with%20a%20dense%20grid%20of%20lit%20windows%2C%20film%20noir%20tone%2C%20cinematic%20movie%20poster%20art%2C%20dramatic%20moody%20lighting%2C%20rich%20cinematic%20color%20grading%2C%20fine%20film%20grain%2C%20premium%20editorial%20composition%2C%20highly%20detailed%2C%20no%20text&width=600&height=800&seq=cover-t10&orientation=portrait",
    short: "城市越大，越有人活在被删除的角落。",
    synopsis:
      "刑警周牧接手一桩看似普通的失踪案，调查却指向一座即将拆迁的老城区。记者温言为了报道真相，也悄悄潜入其中。两人在各自的线索里越走越近，也越走越危险。当旧城最后一片灯光熄灭，他们才看清：被这座城市遗忘的，从来不只是地址，还有人。剧集以冷静的镜头记录都市褶皱里的众生。",
    tags: ["都市", "悬疑", "现实", "群像"],
    releaseDate: "2023-07-14",
    popularity: 85,
    specialIds: ["s01", "s04"],
    reviews: [
      {
        id: "r28",
        user: "社会派",
        rating: 5,
        date: "2023-07-18",
        content: "难得的现实质感悬疑，案件只是壳，讲的是人。",
      },
      {
        id: "r29",
        user: "通勤看剧",
        rating: 4,
        date: "2023-07-25",
        content: "节奏稳，人物动机合理，后半段稍慢但结局很有力量。",
      },
      {
        id: "r30",
        user: "城市漫游者",
        rating: 5,
        date: "2023-08-02",
        content: "镜头里的老城区太有味道了，看完想再去走一走。",
      },
    ],
  },
  {
    id: "t11",
    name: "盛夏的果实",
    type: "tv",
    region: "中国大陆",
    year: 2024,
    genres: ["青春", "爱情"],
    director: "何以晴",
    cast: ["林小满", "江辰", "苏晓棠"],
    duration: "全 24 集",
    rating: 7.9,
    cover:
      "https://readdy.ai/api/search-image?query=sunlit%20summer%20orchard%20with%20two%20young%20figures%20cycling%20along%20a%20country%20road%2C%20warm%20nostalgic%20tone%2C%20cinematic%20movie%20poster%20art%2C%20dramatic%20moody%20lighting%2C%20rich%20cinematic%20color%20grading%2C%20fine%20film%20grain%2C%20premium%20editorial%20composition%2C%20highly%20detailed%2C%20no%20text&width=600&height=800&seq=cover-t11&orientation=portrait",
    short: "那个夏天结下的果子，很多年后才尝到它的味道。",
    synopsis:
      "高考结束的暑假，林小满回到外婆家的小镇，遇到了同样来避暑的江辰。两人从争吵到熟悉，一起看露天电影、摘果子、在河堤上聊未来。夏天结束，他们各自考上不同城市的大学，约定保持联系。多年后，当他们再次回到小镇的果园，才发现有些感情像夏天的果实，需要时间才能尝出甜味。",
    tags: ["青春", "爱情", "夏日", "成长"],
    releaseDate: "2024-06-28",
    popularity: 80,
    specialIds: [],
    reviews: [
      {
        id: "r31",
        user: "夏天限定",
        rating: 4,
        date: "2024-07-02",
        content: "画面好干净，夏天的滤镜拉满，看的时候心情特别好。",
      },
      {
        id: "r32",
        user: "毕业季",
        rating: 4,
        date: "2024-07-08",
        content: "很有共鸣的青春剧，没有狗血，就是那种淡淡的遗憾。",
      },
      {
        id: "r33",
        user: "西瓜味",
        rating: 4,
        date: "2024-07-15",
        content: "适合暑假窝在沙发上看，配角们也都挺可爱的。",
      },
    ],
  },
  {
    id: "t12",
    name: "急诊科风云",
    type: "tv",
    region: "中国大陆",
    year: 2023,
    genres: ["医疗", "职场"],
    director: "苏晓",
    cast: ["顾一鸣", "秦岚", "高博"],
    duration: "全 36 集",
    rating: 8.3,
    cover:
      "https://readdy.ai/api/search-image?query=a%20brightly%20lit%20hospital%20emergency%20corridor%20at%20night%20with%20medical%20drama%20tension%20and%20teal%20white%20tones%2C%20cinematic%20movie%20poster%20art%2C%20dramatic%20moody%20lighting%2C%20rich%20cinematic%20color%20grading%2C%20fine%20film%20grain%2C%20premium%20editorial%20composition%2C%20highly%20detailed%2C%20no%20text&width=600&height=800&seq=cover-t12&orientation=portrait",
    short: "在生死之间的那条走廊上，没有人是旁观者。",
    synopsis:
      "急诊科主任顾一鸣以雷厉风行著称，新来的规培医生秦岚却总用另一种方式对待病人。两人在一次次抢救中碰撞、争执，也在一次次生死面前彼此理解。剧集以急诊科为窗口，串起医生、护士、患者与家属的故事，冷静地呈现医疗现场的高压与温度，也追问医者与普通人之间那条模糊的界线。",
    tags: ["医疗", "职场", "群像", "现实"],
    releaseDate: "2023-09-15",
    popularity: 76,
    specialIds: [],
    reviews: [
      {
        id: "r34",
        user: "白大褂",
        rating: 5,
        date: "2023-09-20",
        content: "医疗细节挺扎实，情感线克制，看得很踏实。",
      },
      {
        id: "r35",
        user: "夜班护士",
        rating: 4,
        date: "2023-09-28",
        content: "很多情节太真实了，看得又揪心又感动。",
      },
      {
        id: "r36",
        user: "大叔看剧",
        rating: 4,
        date: "2023-10-05",
        content: "适合和父母一起看，能聊很多话题，质量在线。",
      },
    ],
  },
  {
    id: "t13",
    name: "星际拓荒者",
    type: "tv",
    region: "美国",
    year: 2025,
    genres: ["科幻", "冒险"],
    director: "Nina Cole",
    cast: ["亚当·卡特", "莉娜·福斯特", "凯文·孙"],
    duration: "全 10 集",
    rating: 8.8,
    cover:
      "https://readdy.ai/api/search-image?query=astronauts%20standing%20on%20an%20alien%20planet%20surface%20under%20twin%20moons%20with%20a%20vast%20sci-fi%20desert%20landscape%2C%20cinematic%20movie%20poster%20art%2C%20dramatic%20moody%20lighting%2C%20rich%20cinematic%20color%20grading%2C%20fine%20film%20grain%2C%20premium%20editorial%20composition%2C%20highly%20detailed%2C%20no%20text&width=600&height=800&seq=cover-t13&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=a%20vast%20alien%20desert%20planet%20with%20twin%20moons%20in%20the%20sky%20and%20a%20lone%20exploration%20rover%20crossing%20the%20dunes%2C%20cinematic%20wide%20film%20still%2C%20dramatic%20atmospheric%20lighting%2C%20rich%20color%20grading%2C%20epic%20composition%2C%20soft%20film%20grain%2C%20highly%20detailed%2C%20no%20text&width=1600&height=900&seq=backdrop-t13&orientation=landscape",
    short: "人类的下一步，踏在一块没人回得来的土地上。",
    synopsis:
      "第一批前往遥远星系建立殖民地的探险队，在抵达目标行星后发现：这里的生态远比预想中更危险，而基地发来的指令也开始变得矛盾。队长亚当必须在科学理想与队员生存之间做出抉择，通讯官莉娜则逐渐怀疑，地球上等他们的，也许早已不是出发时的那个世界。剧集用冷峻的科幻外壳，讲述人类最古老的命题：家在哪里。",
    tags: ["科幻", "太空", "冒险", "美剧"],
    releaseDate: "2025-03-07",
    popularity: 94,
    specialIds: ["s03"],
    reviews: [
      {
        id: "r37",
        user: "太空迷",
        rating: 5,
        date: "2025-03-12",
        content: "世界观宏大，制作精良，每一集都像电影，追得停不下来。",
      },
      {
        id: "r38",
        user: "出差看剧",
        rating: 5,
        date: "2025-03-18",
        content: "人物塑造特别好，不是靠特效堆出来的硬科幻。",
      },
      {
        id: "r39",
        user: "星图",
        rating: 4,
        date: "2025-03-25",
        content: "中段节奏稍慢，但结尾一集直接封神，期待第二季。",
      },
    ],
  },
  {
    id: "t14",
    name: "厨房里的哲学家",
    type: "tv",
    region: "日本",
    year: 2024,
    genres: ["生活", "治愈"],
    director: "田中悠",
    cast: ["小林薰", "安藤樱", "松本真"],
    duration: "全 12 集",
    rating: 8.6,
    cover:
      "https://readdy.ai/api/search-image?query=a%20cozy%20small%20japanese%20diner%20kitchen%20at%20night%20with%20warm%20lantern%20light%20and%20steaming%20pots%2C%20cinematic%20movie%20poster%20art%2C%20dramatic%20moody%20lighting%2C%20rich%20cinematic%20color%20grading%2C%20fine%20film%20grain%2C%20premium%20editorial%20composition%2C%20highly%20detailed%2C%20no%20text&width=600&height=800&seq=cover-t14&orientation=portrait",
    short: "深夜的小厨房里，每道菜背后都藏着一句没说完的话。",
    synopsis:
      "在一家只营业到深夜的小餐馆，老板兼主厨总能从客人的神情里猜出他们真正想要的菜。来这里的客人各有心事：辞职的上班族、和女儿冷战的老教师、刚失恋的年轻厨师。一道道家常料理上桌的同时，那些说不出口的话也被慢慢打开。剧集以食物为引子，温柔地讲述平凡人如何与生活和解。",
    tags: ["治愈", "美食", "日常", "人生"],
    releaseDate: "2024-01-12",
    popularity: 70,
    specialIds: ["s02"],
    reviews: [
      {
        id: "r40",
        user: "胃和心",
        rating: 5,
        date: "2024-01-16",
        content: "每次看完都特别饿，也特别想给家人打个电话，太治愈了。",
      },
      {
        id: "r41",
        user: "深夜食堂粉",
        rating: 5,
        date: "2024-01-22",
        content: "有旧时代那种温情，节奏慢但一点都不闷。",
      },
      {
        id: "r42",
        user: "小碗",
        rating: 4,
        date: "2024-01-29",
        content: "适合睡前看一集，很解压，配乐也舒服。",
      },
    ],
  },
  {
    id: "t15",
    name: "欢乐大本营2025",
    type: "variety",
    region: "中国大陆",
    year: 2025,
    genres: ["游戏", "真人秀"],
    director: "汪洋",
    cast: ["何乐", "谢天", "杜可"],
    duration: "每周五更新",
    rating: 8.0,
    cover:
      "https://readdy.ai/api/search-image?query=a%20colorful%20vibrant%20television%20game%20show%20stage%20with%20confetti%20and%20bright%20playful%20spotlights%2C%20cinematic%20movie%20poster%20art%2C%20dramatic%20moody%20lighting%2C%20rich%20cinematic%20color%20grading%2C%20fine%20film%20grain%2C%20premium%20editorial%20composition%2C%20highly%20detailed%2C%20no%20text&width=600&height=800&seq=cover-t15&orientation=portrait",
    short: "一群人认真玩游戏的快乐，就是最好的下饭综艺。",
    synopsis:
      "全新一季的《欢乐大本营》把游戏难度和笑点一起拉满。固定的快乐家族加上每期到访的飞行嘉宾，在室内外各类关卡里斗智斗勇。本季新增“反转任务”与“观众出题”环节，让每一期的胜负都充满意外。节目不追求复杂设定，只想把最简单直接的快乐送给每一位观众。",
    tags: ["综艺", "搞笑", "游戏", "家庭"],
    releaseDate: "2025-01-03",
    popularity: 90,
    specialIds: [],
    reviews: [
      {
        id: "r43",
        user: "下饭必备",
        rating: 4,
        date: "2025-01-05",
        content: "吃饭的时候看特别合适，全程嘴角就没下来过。",
      },
      {
        id: "r44",
        user: "周末快乐",
        rating: 4,
        date: "2025-01-10",
        content: "新环节挺有意思，嘉宾综艺感在线，全家都能看。",
      },
      {
        id: "r45",
        user: "阿乐",
        rating: 4,
        date: "2025-01-15",
        content: "简单快乐就是顶配，每期都追，减压神器。",
      },
    ],
  },
  {
    id: "t16",
    name: "荒野求生日记",
    type: "variety",
    region: "中国大陆",
    year: 2024,
    genres: ["真人秀", "冒险"],
    director: "田野",
    cast: ["吴山", "李拓", "程野"],
    duration: "全 12 期",
    rating: 8.2,
    cover:
      "https://readdy.ai/api/search-image?query=a%20rugged%20wilderness%20survival%20camp%20beside%20a%20mountain%20river%20at%20dawn%20with%20a%20tent%20and%20a%20small%20campfire%2C%20cinematic%20movie%20poster%20art%2C%20dramatic%20moody%20lighting%2C%20rich%20cinematic%20color%20grading%2C%20fine%20film%20grain%2C%20premium%20editorial%20composition%2C%20highly%20detailed%2C%20no%20text&width=600&height=800&seq=cover-t16&orientation=portrait",
    short: "把六个人丢进荒野，看他们如何重新学会合作。",
    synopsis:
      "六位来自不同领域的嘉宾被送到无人山区，只带着有限的工具和一张手绘地图，需要在十二期里完成取水、生火、搭建庇护所等一系列生存任务。没有剧本、没有救援，只有最真实的困境与协作。节目在展现自然壮美的同时，也记录下人在极限环境中显露的脆弱与坚韧。",
    tags: ["真人秀", "荒野", "挑战", "自然"],
    releaseDate: "2024-04-05",
    popularity: 72,
    specialIds: [],
    reviews: [
      {
        id: "r46",
        user: "户外老张",
        rating: 4,
        date: "2024-04-10",
        content: "拍摄很硬核，风景绝了，比想象中真实很多。",
      },
      {
        id: "r47",
        user: "露营爱好者",
        rating: 5,
        date: "2024-04-18",
        content: "看完立刻想收拾背包出门，嘉宾的成长线很打动人。",
      },
      {
        id: "r48",
        user: "山那边",
        rating: 4,
        date: "2024-04-25",
        content: "没有过度剪辑冲突，难得的一档干净综艺。",
      },
    ],
  },
  {
    id: "t17",
    name: "声动时代",
    type: "variety",
    region: "中国大陆",
    year: 2025,
    genres: ["音乐", "竞技"],
    director: "许晴",
    cast: ["周听", "方也", "陈默言"],
    duration: "全 14 期",
    rating: 8.4,
    cover:
      "https://readdy.ai/api/search-image?query=a%20dramatic%20concert%20stage%20with%20a%20single%20microphone%20in%20a%20spotlight%20and%20a%20music%20competition%20vibe%2C%20cinematic%20movie%20poster%20art%2C%20dramatic%20moody%20lighting%2C%20rich%20cinematic%20color%20grading%2C%20fine%20film%20grain%2C%20premium%20editorial%20composition%2C%20highly%20detailed%2C%20no%20text&width=600&height=800&seq=cover-t17&orientation=portrait",
    short: "不看流量看实力，把舞台交给真正会唱的人。",
    synopsis:
      "《声动时代》邀请不同年龄、不同风格的实力歌手同台竞演。每期以经典曲目改编为主题，歌手通过盲选、组队、对抗等环节争夺最终舞台。节目摒弃滤镜与剧本，用现场收音还原最真实的演唱。从民谣到摇滚，从老歌新唱到原创首演，一场关于声音与热爱的较量就此展开。",
    tags: ["综艺", "音乐", "竞技", "现场"],
    releaseDate: "2025-02-14",
    popularity: 84,
    specialIds: [],
    reviews: [
      {
        id: "r49",
        user: "耳朵怀孕",
        rating: 5,
        date: "2025-02-18",
        content: "现场收音太顶了，好几位歌手的编曲直接封神。",
      },
      {
        id: "r50",
        user: "老歌新听",
        rating: 4,
        date: "2025-02-24",
        content: "改编很有诚意，赛制也还算公平，值得追。",
      },
      {
        id: "r51",
        user: "耳机党",
        rating: 5,
        date: "2025-03-01",
        content: "决赛那几场反复听了好多遍，这档综艺含金量很高。",
      },
    ],
  },
];